import { createApp } from 'vue'
import App from './App.vue'
import '@fortawesome/fontawesome-free/css/all.css';
require('@/assets/main.scss');
createApp(App).mount('#app');